__webpack_require__.p = "/students/university-living-costs-calculator/";